import { render } from "./pricing-switch.vue?vue&type=template&id=96442470&scoped=true&ts=true"
import script from "./pricing-switch.vue?vue&type=script&lang=ts"
export * from "./pricing-switch.vue?vue&type=script&lang=ts"

import "./pricing-switch.vue?vue&type=style&index=0&id=96442470&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96442470"]])

export default __exports__